// @ vendor
import React, { useState, useEffect } from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import PropTypes from 'prop-types'

import './transferView.scss'

import { OKButton } from 'components/commons/OKButton/OKButton';
import OKModal from 'components/commons/OKModal/OKModal'
import { OKCheckbox } from 'commonsComponents/OKCheckbox'

import transferActions from 'actions/transferActions';
import termsAndCondsInfoActions from 'actions/termsAndCondsInfo';

import chatIcon from 'assets/images/transfers/chat_icon.svg'
import movilIcon from 'assets/images/transfers/movil_icon.svg'
import personIcon from 'assets/images/transfers/person_icon.svg'
import hacker from 'assets/images/transfers/hacker.svg'

import {
    TRANSFERS_WARNING_MODAL,
    ACTION_EVENT_VIEW,
    TRANSFERS_WARNING_MODAL_BACK,
    TRANSFERS_WARNING_MODAL_ACCEPT,
    TRANSFERS_WARNING_MODAL_REJECT,
    TRANSFERS_WARNING_MODAL_CONFIRM
} from 'constants/tagging'

import {
    FIRST_STEP,
    BENEFICIARY_TYPE_EXISTING
} from 'constants/index';
import { CHECK_LEGALES_ENABLED } from 'constants/flagBasedFeatures';
import { recordLink } from "utilities/tagging";
import { i18n } from 'core/i18n';


const TransferViewWarningModal = ({
	isOpen,
	actions,
	onSecondaryButtonClick,
	onFailedTermsAcepted,
	termsAndCondsInfo,
	immTransferState,
	immAccountsState,
	immBeneficiaries,
	termsAndCondsActions,
	termsAndCondsCountryFlags,
}) => {
	const [conditionsCheckboxChecked, setConditionsCheckboxChecked] = useState(false)

    const { FormattedText, formatText } = i18n

	useEffect(() => {
        const firstStep = immTransferState.getIn(['steps', FIRST_STEP]);
        const beneficiaryType = firstStep.getIn(['beneficiary', 'type']);
        const beneficiaryExistingId = firstStep.getIn(['beneficiary', 'existing', 'id']);
        const immBeneficiary =
            beneficiaryType === BENEFICIARY_TYPE_EXISTING
                ? immBeneficiaries.getIn(['byId', beneficiaryExistingId])
                : firstStep.getIn(['beneficiary', 'new']);
        const originAccountId = firstStep.get('fromAccount');
        const originAccount = immAccountsState.getIn(['byId', originAccountId]);
        const fromIBAN = originAccount.get("iban");
        const amount = firstStep.get("amount")
        const iban = immBeneficiary.get("iban")

        const customTerms = `${formatText('transferSummary-transferSummary_transferModalWarningCheckboxLabel') } Cuenta Origen:${fromIBAN} Cuenta Destino:${iban} Monto:€${amount}`;
        
		termsAndCondsActions.setTermsAndCondsText(customTerms);

        recordLink(
            window.utag_last_name,
            TRANSFERS_WARNING_MODAL,
            ACTION_EVENT_VIEW
        )
	}, [])

	useEffect(() => {
        if(termsAndCondsInfo.get('requestSuccess')){
            actions.showScamWarning(false);
            actions.setVisibleStep(2);
        }
        if(termsAndCondsInfo.get('error')){
            onFailedTermsAcepted()
        }
	}, [termsAndCondsInfo])

	const handlePrimaryButtonClick = () => {
        recordLink(
            window.utag_last_name,
            TRANSFERS_WARNING_MODAL,
            TRANSFERS_WARNING_MODAL_CONFIRM
        )

        if (termsAndCondsCountryFlags) {
            return actions.modalWarningValidate();
        }

        actions.showScamWarning(false);
        actions.setVisibleStep(2);
    }

    const handleSecondaryButtonClick = () => {
        recordLink(
            window.utag_last_name,
            TRANSFERS_WARNING_MODAL,
            TRANSFERS_WARNING_MODAL_BACK
        )
        onSecondaryButtonClick()
    }

    const handleConditionsCheckbox = (event) => {
        setConditionsCheckboxChecked(event.target.checked)

        const checkboxTaggingLabel = 
            event.target.checked ?
            TRANSFERS_WARNING_MODAL_ACCEPT :
            TRANSFERS_WARNING_MODAL_REJECT;

        recordLink(
            window.utag_last_name,
            TRANSFERS_WARNING_MODAL,
            checkboxTaggingLabel
        )
    }

	const modalContent = () =>  (
    <div>
        <img className={'transfer-view__modaltransfer-headerimg'} src={hacker}/>
        <FormattedText
            value="transferSummary-transferSummary_transferModalWarningSubtitle"
		/>
        <div className={'transfer-view__modaltransfer-list'}>
            <img className={'transfer-view__modaltransfer-icon'} src={movilIcon}/>
            <FormattedText
                value="transferSummary-transferSummary_transferModalWarningColText1"
			/>
            <FormattedText
                value="transferSummary-transferSummary_transferModalWarningColQuote1"
			/>
            <img className={'transfer-view__modaltransfer-icon'} src={chatIcon}/>
            <FormattedText
                value="transferSummary-transferSummary_transferModalWarningColText2"
			/>
            <FormattedText
                value="transferSummary-transferSummary_transferModalWarningColQuote2"
			/>
            <img className={'transfer-view__modaltransfer-icon'} src={personIcon} />
            <FormattedText
                value="transferSummary-transferSummary_transferModalWarningColText3"
			/>
            <FormattedText
                value="transferSummary-transferSummary_transferModalWarningColQuote3"
			/>
        </div>
    </div>
    )

	return (
    <OKModal
        overlayClassName={"ok-modal-warning"}
        primaryButtonLoading={termsAndCondsInfo.get('isFetching')}
        content={modalContent()}
        size="large"
        contentOverflow="auto"
        headerType="custom"
        headerContent={
            <h3 className="transfer-view__modaltransfer-title">
                <FormattedText value="transferSummary-transferSummary_transferModalWarningTitle"/>
            </h3>
		}
        isOpen={isOpen}
        titleAlignment="center"
        contentFooter={
            <div>
                <div className="transfer-view__modaltransfer-checkboxcontainer">
                    <OKCheckbox
                        idName="transferViewModal-checkbox"
                        onChange={handleConditionsCheckbox}
                        label={
                            <FormattedText value="transferSummary-transferSummary_transferModalWarningCheckboxLabel" />
									}
                        value={conditionsCheckboxChecked}
								/>
                </div>
                <div className="transfer-view__modaltransfer-footerbuttons">
                    <OKButton
                        modifier="link-ghost"
                        onClick={handleSecondaryButtonClick}
					>
                        <FormattedText value="transferSummary-transferSummary_transferModalWarningSecondaryButton" />
                    </OKButton>
                    <OKButton
                        onClick={handlePrimaryButtonClick}
                        loading={termsAndCondsInfo.get('isFetching')}
                        disabled={!conditionsCheckboxChecked}
								>
                        <FormattedText value="transferSummary-transferSummary_transferModalWarningPrimaryButton" />
                    </OKButton>
                </div>   
            </div>
		}
        customCloseButton={<div/>}
	/>)
}

TransferViewWarningModal.propTypes = {
    termsAndCondsActions: PropTypes.object,
    onFailedTermsAcepted: PropTypes.func,
    actions: PropTypes.object,
    termsAndCondsInfo: PropTypes.object,
    isOpen: PropTypes.bool,
    onSecondaryButtonClick: PropTypes.func,
    immTransferState: PropTypes.object,
    immBeneficiaries: PropTypes.object,
    immAccountsState: PropTypes.object,
    termsAndCondsCountryFlags: PropTypes.bool
};

module.exports.constructor = TransferViewWarningModal;
module.exports.TransferViewWarningModal = connect(
    state => ({
        termsAndCondsInfo: state.termsAndCondsInfo,
        immTransferState: state.transfer,
        immBeneficiaries: state.beneficiaries,
        immAccountsState: state.accounts,
        termsAndCondsCountryFlags: state.flagBasedFeatures.get(CHECK_LEGALES_ENABLED)
    }),
    dispatch => ({
        actions: bindActionCreators(transferActions, dispatch),
        termsAndCondsActions: bindActionCreators(termsAndCondsInfoActions, dispatch),
    })
)(TransferViewWarningModal);
